export default "__VITE_ASSET__118e4ec7__"